
export default (state = false, action) => {
  let { type, payload } = action
  switch (type) {
    case 'SELECTED_3DMAP':
      return true
    case 'UNSELECTED_3DMAP':
      return false
    case 'LOGOUT':
      return false
    default:
      return state
  }
}
